import { Star, Truck, TicketPercent } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/lib/site";

export default function FlyerWelcome() {
  return (
    <div className="min-h-screen bg-slate-300 py-10 print:bg-white print:py-0">
      <div className="mx-auto flex justify-center pb-6 print:hidden">
        <button
          data-testid="flyer-print-button"
          onClick={() => window.print()}
          className="rounded-full bg-brand-navy px-8 py-3 font-display text-sm font-extrabold uppercase tracking-widest text-white shadow-lg transition-transform hover:scale-105"
        >
          Print / Save as PDF
        </button>
      </div>

      <div data-testid="flyer-page" className="mx-auto bg-white shadow-2xl print:shadow-none" style={{ width: "8.5in", minHeight: "11in" }}>
        <div className="flex items-center justify-between bg-brand-navy px-10 py-6 text-white">
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-fall-amber">
              <Star className="h-7 w-7 fill-brand-navy text-brand-navy" />
            </span>
            <div>
              <p className="font-display text-2xl font-extrabold tracking-tight">OXFORD CLEANERS</p>
              <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-amber-300">Veteran &amp; Family-Owned · Chandler, AZ</p>
            </div>
          </div>
          <p className="text-right text-xs font-semibold leading-relaxed text-slate-300">
            4.7★ on Google
            <br />
            90+ neighbor reviews
          </p>
        </div>

        <div className="px-10 pt-10 text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-fall-amber px-5 py-1.5 text-xs font-extrabold uppercase tracking-[0.25em] text-brand-navy">
            <TicketPercent className="h-4 w-4" /> New customer gift
          </p>
          <h1 className="mt-5 font-display text-6xl font-extrabold leading-none tracking-tight text-brand-navy">
            $10 <span className="text-fall-orange">OFF</span>
          </h1>
          <p className="mt-3 font-display text-2xl font-bold text-brand-navy">your first pickup &amp; delivery order</p>
          <p className="mx-auto mt-3 max-w-md text-sm font-semibold leading-relaxed text-slate-500">
            Dry cleaning, wash &amp; fold, comforters, suits, dresses — we pick up from your doorstep
            and bring it all back fresh in about 48 hours. Delivery is always free.
          </p>
        </div>

        <div className="mt-8 px-10">
          <div className="flex items-center gap-8 rounded-3xl border-4 border-dashed border-fall-amber bg-fall-bg p-8">
            <img data-testid="flyer-qr" src="/images/qr_welcome.png" alt="Scan to claim your $10 voucher at oxford-cleaners.com/welcome" className="h-40 w-40 shrink-0 rounded-2xl bg-white p-2 shadow-md" />
            <div>
              <p className="font-display text-2xl font-extrabold text-brand-navy">Scan to claim your $10</p>
              <p className="mt-1.5 text-sm font-semibold leading-relaxed text-slate-600">
                Point your phone camera at the code — it opens our welcome page. Leave your name and
                number and we&apos;ll text you to schedule your free pickup.
              </p>
              <p className="mt-2 rounded-lg bg-white px-3 py-1.5 font-mono text-sm font-bold text-brand-blue">
                oxford-cleaners.com/welcome
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 px-10 pt-7 text-center">
          {["Scan & claim $10", "We text you to schedule", "Fresh clothes, $10 less"].map((s, i) => (
            <div key={s} className="rounded-xl bg-slate-50 p-3.5">
              <p className="font-display text-lg font-extrabold text-fall-orange">0{i + 1}</p>
              <p className="text-xs font-semibold text-slate-600">{s}</p>
            </div>
          ))}
        </div>

        <div className="mt-7 flex items-center gap-3 bg-fall-orange px-10 py-5 text-white">
          <Truck className="h-8 w-8 shrink-0" />
          <div>
            <p className="font-display text-lg font-extrabold uppercase tracking-wide">Free pickup &amp; delivery</p>
            <p className="text-xs font-semibold text-amber-100">
              Chandler · Gilbert · Tempe · Ahwatukee · Sun Lakes · Maricopa
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between bg-brand-navy px-10 py-6 text-white">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-300">Prefer to talk?</p>
            <a data-testid="flyer-phone-link" href={PHONE_TEL} className="font-display text-3xl font-extrabold tracking-tight">
              {PHONE}
            </a>
            <p className="text-sm font-semibold text-slate-300">5865 W Ray Rd, Suite 3 · Mon–Sat</p>
          </div>
          <p className="max-w-[2.8in] text-right text-[10px] font-semibold leading-relaxed text-slate-400">
            One voucher per new customer. Mention it when we deliver — we&apos;ll take $10 off your total.
          </p>
        </div>
      </div>
    </div>
  );
}
